import { Link } from 'react-router-dom';

export default function Footer() {
  const links = [
    { label: 'Home',              to: '/' },
    { label: 'About Us',          to: '/about' },
    { label: 'Privacy & Policy',  to: '/privacy' },
    { label: 'Support',           to: '/support' },
    { label: 'Contact Us',        to: '/contact' },
  ];

  return (
    <footer style={{
      background: 'var(--navy)',
      borderTop: '1px solid rgba(232,96,74,0.12)',
      padding: '3rem clamp(1rem,4vw,3rem) 2rem',
      textAlign: 'center',
    }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', marginBottom: '1.5rem' }}>
          <img
            src="/imags/hadafi_white_logo.png"
            alt="Hadafi"
            style={{ height: 38, width: 'auto', display: 'block' }}
          />
        </Link>

        <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: '1.5rem' }}>
          Built by players, for players in the UAE.
        </p>

        {/* Nav links */}
        <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '1.5rem' }}>
          {links.map(({ label, to }) => (
            <Link key={to} to={to} style={{
              color: 'var(--muted)', fontSize: 13, fontFamily: 'var(--font-b)',
              textDecoration: 'none', transition: 'color 0.2s',
            }}
              onMouseEnter={e => e.target.style.color = 'var(--coral)'}
              onMouseLeave={e => e.target.style.color = 'var(--muted)'}
            >{label}</Link>
          ))}
        </div>

        {/* Social / contact */}
        <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', marginBottom: '1.5rem' }}>
          {[
            { label: 'Instagram', href: 'https://instagram.com' },
            { label: 'Twitter/X',  href: 'https://x.com' },
            { label: 'LinkedIn',  href: 'https://linkedin.com' },
          ].map(({ label, href }) => (
            <a key={label} href={href} target="_blank" rel="noreferrer" style={{
              color: 'var(--muted)', fontSize: 12, fontFamily: 'var(--font-m)',
              textDecoration: 'none', transition: 'color 0.2s',
            }}
              onMouseEnter={e => e.target.style.color = 'var(--coral)'}
              onMouseLeave={e => e.target.style.color = 'var(--muted)'}
            >{label}</a>
          ))}
        </div>

        <div style={{ height: 1, background: 'rgba(122,155,181,0.12)', marginBottom: '1.5rem' }} />

        <p style={{ color: 'var(--muted)', fontSize: 12, fontFamily: 'var(--font-m)' }}>
          © {new Date().getFullYear()} Hadafi. All rights reserved. &nbsp;|&nbsp; hadafi.ae
          &nbsp;|&nbsp; hello@hadafi.ae
        </p>
      </div>
    </footer>
  );
}
